import { Component, inject, OnDestroy } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { RouterLink } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SignalsStoreService } from '../../signals-store.service';

@Component({
  selector: 'app-pending-payment-method-no-signup',
  providers: [provideNativeDateAdapter()],
  imports: [RouterLink],
  template: `
  <div class="container">
    <div class="row">
      <div class="col mb-3 text-center">
        <small>
          Your Membership Is Almost Active
        </small><br>
        <small>
          To activate your $25 annual membership and start shopping, please add a payment method now. This unlocks full access to The Produce Box—bringing fresh, local food straight to your door with ease.
        </small>
      </div>
    </div>

    <div class="row mt-0 mb-2 justify-content-center">
      <div class="col-md-auto">
        <button
          type="button"
          class="btn btn-primary"
          (click)="activeModal.close()"
          [routerLink]="'settings/billing/payment-method'">
          Add Payment Method
        </button>
      </div>
    </div>
  </div>
`
})
export class PendingPaymentMethodNoSignupComponent implements OnDestroy {
  activeModal = inject(NgbActiveModal);
  #signalStoreService = inject(SignalsStoreService);

  constructor() {
    this.#signalStoreService.requirePaymentMethodOpened.set(true);
  }

  ngOnDestroy(): void {
    this.#signalStoreService.requirePaymentMethodOpened.set(false);
  }
}
